/*
  Brain Age quiz landing page (templates/page.brain-age.liquid).
  Everything is wrapped in an IIFE so the page's short helpers (notably `$`) stay off the global scope and
  cannot collide with globals that apps inject through content_for_header.
*/
(function () {
  'use strict'
// ---------- state ----------
const S = { ageMid:null, rx:null, mem:null, rec:null, brainAge:null, offset:0 };
const $ = id => document.getElementById(id);
const GA_MEASUREMENT_ID = 'G-E315LQ5C1F';
const SCREEN_STEPS = {
  's-rx': { quiz_step: 'reaction', quiz_step_number: 2 },
  's-mem': { quiz_step: 'memory', quiz_step_number: 3 },
  's-rec': { quiz_step: 'recall', quiz_step_number: 4 },
  's-results': { quiz_step: 'results', quiz_step_number: 5 }
};
function trackQuiz(eventName, params, onDone){
  const payload = Object.assign({}, params || {});
  if (S.ageMid != null) payload.age_band = String(S.ageMid);
  payload.send_to = GA_MEASUREMENT_ID;
  const finish = typeof onDone === 'function' ? onDone : null;
  if (typeof window.gtag !== 'function') {
    if (finish) finish();
    return;
  }
  if (finish) {
    let done = false;
    const once = () => { if (done) return; done = true; finish(); };
    payload.event_callback = once;
    payload.event_timeout = 1500;
  }
  window.gtag('event', eventName, payload);
}
function progress(step, extra){
  const payload = Object.assign({ quiz_step: step }, extra || {});
  trackQuiz('brain_age_progress', payload);
}
function show(id){
  document.querySelectorAll('.screen').forEach(s=>s.classList.remove('active'));
  $(id).classList.add('active');
  window.scrollTo(0,0);
  const step = SCREEN_STEPS[id];
  if (step) progress(step.quiz_step, { quiz_step_number: step.quiz_step_number });
}
function toast(msg){ const t=$('toast'); t.textContent=msg; t.classList.add('show'); setTimeout(()=>t.classList.remove('show'), 2600); }

// ---------- intro ----------
$('agegrid').addEventListener('click', e=>{
  const b = e.target.closest('button'); if(!b) return;
  document.querySelectorAll('#agegrid .btn').forEach(x=>x.classList.remove('sel'));
  b.classList.add('sel'); S.ageMid = +b.dataset.mid;
  $('startBtn').disabled = false; $('startBtn').style.opacity = 1;
  progress('age_selected', { quiz_step_number: 1 });
});
$('startBtn').addEventListener('click', ()=>{ startReaction(); show('s-rx'); });

// ---------- round 1: reaction ----------
let rxState;
function startReaction(){
  rxState = { trial:0, times:[], phase:'idle', t0:0, to:null };
  document.querySelectorAll('#rxdots span').forEach(d=>d.classList.remove('hit'));
  setRx('idle'); $('rxCount').textContent = '1 of 4';
}
function setRx(phase, msg){
  const box = $('rxbox'); rxState.phase = phase;
  box.className = 'rxbox' + (phase==='wait'?' wait':phase==='go'?' go':'');
  if(phase==='idle') box.innerHTML = '<div class="big">Tap to Start</div><div class="small">Wait for green, then tap fast.</div>';
  if(phase==='wait') box.innerHTML = '<div class="big">Wait...</div><div class="small">'+(msg||'Green means go.')+'</div>';
  if(phase==='go')   box.innerHTML = '<div class="big">Tap Now!</div>';
}
function rxTap(){
  if(!rxState) return;
  if(rxState.phase==='idle'){ setRx('wait'); armDelay(); }
  else if(rxState.phase==='wait'){ clearTimeout(rxState.to); setRx('wait','Too soon! Wait for green.'); rxState.phase='cool'; setTimeout(()=>{ setRx('wait'); armDelay(); }, 700); }
  else if(rxState.phase==='go'){
    const ms = performance.now() - rxState.t0;
    rxState.times.push(ms); document.querySelectorAll('#rxdots span')[rxState.trial].classList.add('hit');
    rxState.trial++;
    if(rxState.trial>=4){ finishReaction(false); }
    else { $('rxCount').textContent = (rxState.trial+1)+' of 4'; setRx('wait'); armDelay(); }
  }
}
$('rxbox').addEventListener('click', rxTap);
// desktop: space bar taps the reaction round (only while round 1 is on screen)
document.addEventListener('keydown', e=>{
  if(e.code!=='Space') return;
  if(!$('s-rx').classList.contains('active')) return;
  e.preventDefault(); rxTap();
});
function armDelay(){ rxState.to = setTimeout(()=>{ rxState.t0 = performance.now(); setRx('go'); }, 900+Math.random()*1600); }
function finishReaction(skipped){
  clearTimeout(rxState.to);
  S.rx = skipped ? null : { avg: rxState.times.reduce((a,b)=>a+b,0)/rxState.times.length, best: Math.min.apply(null, rxState.times) };
  progress('reaction_complete', { round_result: skipped ? 'skipped' : 'completed' });
  $('interText').textContent = "Excellent! Let's Continue...";
  $('interBtn').textContent = "Start Quiz 2";
  $('interBtn').onclick = ()=>{ startMemory(); show('s-mem'); };
  show('s-inter');
}

// ---------- round 2: memory, 8 pairs, re-flip tracking ----------
const MEMORY_LIMIT_MS = 45000;
let memState;
function startMemory(){
  const syms = ['🌿','☀️','🔑','🎵','🍎','⭐','🕰️','🧩'];
  const deck = [...syms, ...syms].sort(()=>Math.random()-.5);
  memState = { open:[], matched:0, tries:0, reflips:0, seen:new Set(), t0:performance.now(), timer:null, deadline:null, lock:false, finished:false };
  $('memTimer').textContent='45s';
  $('memSkip').disabled=false;
  const grid = $('memGrid'); grid.innerHTML='';
  deck.forEach((sym,idx)=>{
    const c = document.createElement('div'); c.className='card';
    c.innerHTML = '<span class="face">'+sym+'</span>'; c.dataset.sym = sym; c.dataset.idx = idx;
    c.addEventListener('click', ()=>flipCard(c));
    grid.appendChild(c);
  });
  memState.timer = setInterval(()=>{
    const remaining=Math.max(0,Math.ceil((MEMORY_LIMIT_MS-(performance.now()-memState.t0))/1000));
    $('memTimer').textContent=remaining+'s';
  },250);
  memState.deadline=setTimeout(()=>finishMemory('timeout'),MEMORY_LIMIT_MS);
}
function flipCard(c){
  if(memState.finished || memState.lock || c.classList.contains('flip') || c.classList.contains('done')) return;
  if(memState.seen.has(c.dataset.idx)) memState.reflips++;
  memState.seen.add(c.dataset.idx);
  c.classList.add('flip'); memState.open.push(c);
  if(memState.open.length===2){
    memState.tries++; memState.lock = true;
    const [a,b] = memState.open;
    if(a.dataset.sym===b.dataset.sym){
      setTimeout(()=>{ if(memState.finished) return; a.classList.add('done'); b.classList.add('done'); a.classList.remove('flip'); b.classList.remove('flip');
        memState.open=[]; memState.lock=false; memState.matched++;
        if(memState.matched===8) finishMemory('completed');
      },230);
    } else {
      setTimeout(()=>{ if(memState.finished) return; a.classList.remove('flip'); b.classList.remove('flip'); memState.open=[]; memState.lock=false; },620);
    }
  }
}
function finishMemory(reason){
  if(!memState || memState.finished) return;
  memState.finished=true;
  progress('memory_complete', { round_result: reason, pairs_matched: memState.matched });
  clearInterval(memState.timer);
  clearTimeout(memState.deadline);
  $('memSkip').disabled=true;
  const elapsed=Math.min((performance.now()-memState.t0)/1000,45);
  const skipped=reason!=='completed';
  S.mem = skipped ? null : { time:elapsed, tries:memState.tries, reflips:memState.reflips };
  S.memExit = {reason:reason,matched:memState.matched};
  $('interText').innerHTML = "Last Quiz! This One Is <i>Really</i> Hard.";
  $('interBtn').textContent = "Start Quiz 3";
  $('interBtn').onclick = ()=>{ startRecall(); show('s-rec'); };
  show('s-inter');
}
$('memSkip').addEventListener('click',()=>finishMemory('skipped'));

// ---------- round 3: word recall ----------
// Words draw fresh from a bank each play (replay value): 6 targets + 9 decoys per round.
const WORD_BANK = ['GARDEN','ANCHOR','VIOLIN','MARBLE','LANTERN','SADDLE','CANDLE','RIBBON','HAMMER',
  'ORCHARD','MIRROR','BASKET','THIMBLE','COMPASS','TEAPOT','WALNUT','HARBOR','MEADOW','PILLOW','TUNNEL',
  'CIRCUS','FALCON','BUTTON','CASTLE','PENCIL','WAGON','TROPHY','BARREL','CANYON','SPARROW','TURNIP',
  'LADDER','PUPPET','ENGINE','ISLAND','BLANKET'];
function shuffle(a){ for(let i=a.length-1;i>0;i--){ const j=Math.floor(Math.random()*(i+1)); const t=a[i]; a[i]=a[j]; a[j]=t; } return a; }
let recState, recWords = { targets:[], decoys:[] };
function startRecall(){
  recState = { picks:new Set(), done:false };
  const pool = shuffle([...WORD_BANK]);
  recWords.targets = pool.slice(0,6);
  recWords.decoys  = pool.slice(6,15);
  $('recStudy').style.display='block'; $('recPick').style.display='none'; $('recPhase').textContent='Memorize';
  const mw = $('memWords'); mw.innerHTML='';
  recWords.targets.forEach(w=>{ const d=document.createElement('div'); d.textContent=w; mw.appendChild(d); });
  const bar = $('recBar'); bar.style.transition='none'; bar.style.width='100%';
  setTimeout(()=>{ bar.style.transition='width 6s linear'; bar.style.width='0%'; }, 60);
  recState.to = setTimeout(showPickGrid, 6100);
}
function showPickGrid(){
  recState.studyEnd = performance.now();
  $('recStudy').style.display='none'; $('recPick').style.display='block'; $('recPhase').textContent='Pick 6';
  const all = shuffle([...recWords.targets, ...recWords.decoys]);
  const pg = $('pickGrid'); pg.innerHTML='';
  all.forEach(w=>{
    const p = document.createElement('div'); p.className='pick'; p.textContent=w;
    p.addEventListener('click', ()=>{
      if(recState.done) return;
      if(recState.picks.has(w)){ recState.picks.delete(w); p.classList.remove('sel'); }
      else if(recState.picks.size<6){ recState.picks.add(w); p.classList.add('sel'); }
      $('pickStatus').textContent = recState.picks.size+' of 6 selected';
      if(recState.picks.size===6){ recState.done=true; setTimeout(()=>finishRecall(false), 500); }
    });
    pg.appendChild(p);
  });
  $('pickStatus').textContent = '0 of 6 selected';
}
function finishRecall(skipped){
  if(recState && recState.to) clearTimeout(recState.to);
  progress('recall_complete', { round_result: skipped ? 'skipped' : 'completed' });
  if(skipped){ S.rec = null; }
  else {
    let hits=0, falses=0;
    recState.picks.forEach(w=>{ if(recWords.targets.includes(w)) hits++; else falses++; });
    S.rec = { hits:hits, falses:falses, elapsed: recState.studyEnd ? (performance.now()-recState.studyEnd)/1000 : null };
  }
  computeScore(); show('s-results');
}

// ---------- scoring: par-based engine (v3.3) ----------
// PAR is an internal, aspirational standard per band (think par in golf): a sharp
// day for that band, NOT a population average. It is never printed or claimed on
// the page, so it makes no claims. Being under par costs years faster (0.28/pt)
// than being over par earns them (0.20/pt); caps stay -8/+15. Tuned in
// engine_sim.js (20k simulated players per band) so ~75-80% land older
// (median +3..+5) and ~15% honestly land younger.
function computeScore(){
  const mid = S.ageMid || 60;
  const par = {
    40:{ms:355, t:50,  tries:22, rf:3, hits:5.5},
    50:{ms:390, t:58,  tries:23, rf:4, hits:5},
    60:{ms:430, t:70,  tries:25, rf:5, hits:5},
    70:{ms:480, t:90,  tries:27, rf:6, hits:5},
    78:{ms:535, t:105, tries:29, rf:7, hits:4}
  }[mid];
  const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
  const rxScore  = S.rx  ? clamp(50 - (S.rx.avg-par.ms)/3, 0, 100) : 40;
  const memScore = S.mem ? clamp(50 - (S.mem.time-par.t)*0.8 - (S.mem.tries-par.tries)*1.2 - (S.mem.reflips-par.rf)*1.5, 0, 100) : 40;
  const recScore = S.rec ? clamp(50 + (S.rec.hits-par.hits)*10 - S.rec.falses*3, 0, 100) : 40;
  const comp = memScore*.4 + rxScore*.3 + recScore*.3;
  const raw = comp < 50 ? (50-comp)*0.28 : -(comp-50)*0.20;
  S.offset = clamp(Math.round(raw), -8, 15);
  S.brainAge = Math.max(25, mid + S.offset);

  // round tiers off the par scores (good 60+, bad <=40, else average)
  S.scores = { rx:Math.round(rxScore), mem:Math.round(memScore), rec:Math.round(recScore) };
  const tier = s => s>=60 ? 'good' : (s<=40 ? 'bad' : 'avg');

  // age gap line (COPY 1: "actual age range" per the resolved Isaac/Brandon comment thread)
  const yr = n => n===1 ? '1 year' : n+' years';
  $('ageGap').innerHTML = S.offset>0
    ? '<b>Uh-oh!</b> Based on your quiz results, your brain age is <b>'+yr(S.offset)+' older</b> than your actual age range. Let\'s see why...'
    : (S.offset<0
      ? '<b style="color:var(--sage-deep);">Fairly strong, with room to improve!</b> Based on your quiz results, your brain age is about '+yr(Math.abs(S.offset))+' younger than your actual age range. Let\'s see why...'
      : '<b style="color:var(--sage-deep);">You\'re on the right track!</b> Based on your quiz results, your brain age is '+S.brainAge+', which is pretty close to your actual age range. Let\'s see why...');

  // round cards: Brandon's tiered copy, auto-filled from session data (edits per the claims-filter note)
  const rxMs = S.rx ? Math.round(S.rx.avg) : null;
  const rxBest = S.rx ? Math.round(S.rx.best) : null;
  if(S.rx){
    const t = tier(S.scores.rx);
    const line = t==='bad'
      ? "This round tested your brain's <b>processing speed</b>. Your results suggest there's room to strengthen these skills. Consider this a nudge to give your brain some support."
      : (t==='avg'
      ? "This round tested your brain's <b>processing speed</b>. Your reaction time is in the average range. A solid base to keep sharp."
      : "You're quick on the draw, but you could always be quicker! Your results show sharp <b>processing speed</b> and <b>motor response</b> skills.");
    $('stingRx').innerHTML = '<b>Round 1: Reaction Time · Average: '+rxMs+'ms · Fastest: '+rxBest+'ms</b><span>'+line+'</span>';
  } else {
    $('stingRx').innerHTML = '<b>Round 1: Reaction Time (skipped)</b><span>Demo skip. Live version shows your average and fastest tap.</span>';
  }
  const rf = S.mem ? S.mem.reflips : null;
  if(S.mem){
    const t = tier(S.scores.mem);
    const cards = rf===1 ? '1 card' : rf+' cards';
    const line = rf===0
      ? 'A clean run: you never reopened a card. That is strong <b>memory</b> at work. But even a strong memory can use extra support.'
      : (t==='bad'
      ? 'This round tested <b>memory</b>. You reopened '+cards+' you\'d already seen. That "I just saw it" feeling you\'re having now... That\'s called your working memory.'
      : (t==='avg'
      ? 'This tested your <b>memory</b>. You reopened '+cards+' you\'d already seen, suggesting there may be room to strengthen your ability to remember and recall information.'
      : 'This round tested <b>memory</b>. You reopened '+cards+' you\'d already seen, showing you have a strong ability to remember information. But even a strong memory can use extra support.'));
    $('stingMem').innerHTML = '<b>Round 2: Memory Match · '+(rf===0 ? 'Clean run' : cards+' reopened')+'</b><span>'+line+'</span>';
  } else {
    const timedOut=S.memExit && S.memExit.reason==='timeout';
    const pairs=S.memExit ? S.memExit.matched : 0;
    $('stingMem').innerHTML = '<b>Round 2: Memory Match ('+(timedOut?'time expired':'skipped')+')</b><span>You matched '+pairs+' of 8 pairs before moving on.</span>';
  }
  if(S.rec){
    const t = tier(S.scores.rec);
    const line = t==='bad'
      ? "You remembered "+S.rec.hits+" out of 6 words. Storing and recalling new information is a skill, and skills grow with use. There's definitely room to improve."
      : (t==='avg'
      ? "You remembered "+S.rec.hits+" out of 6 words. Your ability to store and recall new information is about average. But it's a great baseline to build on."
      : "You remembered "+S.rec.hits+" out of 6 words. Impressive! Your ability to store and recall new information appears to be a strength. Keep building on it!");
    $('stingRec').innerHTML = '<b>Round 3: Word Recall · '+S.rec.hits+' of 6 words</b><span>'+line+'</span>';
  } else {
    $('stingRec').innerHTML = '<b>Round 3: Word Recall (skipped)</b><span>Demo skip. Live version shows how many of the 6 came back.</span>';
  }

  // About Your Brain Score: Brandon's three variants (big gap 7+, some gap 0 to 6, aged younger)
  const p1standard = '<p class="expl"><b>Surprised by your score? You\'re not alone.</b> These quizzes tested your brain\'s processing speed, memory, and recall.</p>';
  $('aboutBlock').innerHTML = S.offset>=7
    ? p1standard+'<p class="expl">Your <b>Brain Age is a snapshot of how you performed today</b>, not a final verdict! <b>The good news? There\'s always room to improve.</b> With a little practice and the right support, you can keep working toward your best score yet.</p>'
    : (S.offset>=0
    ? p1standard+'<p class="expl">Your <b>Brain Age is a snapshot of how you performed today</b>, not a final verdict! Think of it as a starting point. With practice and the right support, there\'s always an opportunity to do better.</p>'
    : '<p class="expl"><b>Surprised by your score? You\'re not alone.</b> These quizzes tested processing speed, memory, and recall, all of which can be influenced by factors like age, stress, and sleep.</p><p class="expl">Your <b>Brain Age is a snapshot of how you performed today</b>, not a final verdict! No matter how high you scored, there\'s always room to improve.</p>');

  // animate
  let n = Math.max(25, S.brainAge-14);
  const iv = setInterval(()=>{ n++; $('brainAgeNum').textContent = n; if(n>=S.brainAge) clearInterval(iv); }, 45);
  const pct = clamp(comp/100, 0, 1);
  setTimeout(()=>{ $('gaugeArc').style.transition='stroke-dashoffset 1.2s ease'; $('gaugeArc').style.strokeDashoffset = 314 - 314*pct; }, 150);
}

// ---------- CTA: Brain-R with AppLovin playable UTMs ----------
const CTA_URL = 'https://stonehengehealth.com/pages/brain-r?rs_source=brain_age';
function goToCta(){
  if(window.mraid && typeof window.mraid.open==='function') window.mraid.open(CTA_URL);
  else location.href=CTA_URL;
}
function cta(){
  trackQuiz('brain_age_cta_click', { quiz_step: 'cta', quiz_step_number: 6 }, goToCta);
}
function replay(){
  progress('replay');
  toast('Restarting the games...');
  setTimeout(()=>{ startReaction(); show('s-rx'); }, 900);
}
  // These two replaced inline onclick attributes, which the IIFE puts out of reach.
  $('ctaBtn').addEventListener('click', cta)
  $('replayBtn').addEventListener('click', replay)
})()